import { useEffect } from 'react';
import { styled, CircularProgress } from '@mui/material';
import { RouteComponentProps } from '@reach/router';
import { useLazyQuery } from '@apollo/client';
import { useAuth } from '@calefy-inc/authentication';
import { graphql } from '../../gql';
// Assume LIST_TMP_FILES exists and returns { listTmpFiles: string[] }

interface AdminPanelListTmpFilesProps extends RouteComponentProps {}

export function AdminPanelListTmpFiles(_props: AdminPanelListTmpFilesProps) {
  const { token } = useAuth();
  const [fetchTmpFiles, { loading, error, data }] =
    useLazyQuery(LIST_TMP_FILES);

  useEffect(() => {
    if (token) {
      fetchTmpFiles({ variables: { token } });
    }
  }, [token, fetchTmpFiles]);

  return (
    <ListTmpFilesContainer>
      <h2>Temporary Files</h2>
      {loading ? <CircularProgress /> : null}
      {error ? <div>{String(error.message || error)}</div> : null}
      {data &&
      Array.isArray(data.listTmpFiles) &&
      data.listTmpFiles.length > 0 ? (
        <ul>
          {data.listTmpFiles.map((file: string) => (
            <li key={file}>{file}</li>
          ))}
        </ul>
      ) : data &&
        Array.isArray(data.listTmpFiles) &&
        data.listTmpFiles.length === 0 ? (
        <div>No temporary files found.</div>
      ) : null}
    </ListTmpFilesContainer>
  );
}

const ListTmpFilesContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  background: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}));

const LIST_TMP_FILES = graphql(`
  query listTmpFiles($token: String!) {
    listTmpFiles(token: $token)
  }
`);
